module.exports = __webpack_public_path__ + "img/table-picnic.8afb2c91.svg";